import {
	ResponsiveContainer,
	XAxis,
	YAxis,
	Tooltip,
	LabelList,
	ScatterChart,
	Scatter,
	Label,
	ZAxis,
	ReferenceLine,
	CartesianGrid,
	Legend,
} from "recharts";

import { numberFormatter } from "../../utils";

const ParametricScatter = (props: any) => {
	let data: any = props.data;

	const customTooltip = ({ active, payload }: any) => {
		if (active && payload && payload.length) {
			const data = payload[0].payload;
			return (
				<div className="custom-tooltip">
					<p className="label" style={{ padding: "0", margin: "0" }}>
						<label
							style={{
								color: "#C8C8C8",
								fontSize: "10px",
								fontWeight: "normal",
							}}
						>
							Material:{" "}
						</label>
						<label
							style={{
								color: "#EAEAEA",
								fontSize: "10px",
								fontWeight: "bold",
							}}
						>
							{data.MaterialNumber}
						</label>
					</p>
					<p className="label" style={{ padding: "0", margin: "0" }}>
						<label
							style={{
								color: "#C8C8C8",
								fontSize: "10px",
								fontWeight: "normal",
							}}
						>
							Modelled Unit Price:{" "}
						</label>
						<label
							style={{
								color: "#EAEAEA",
								fontSize: "10px",
								fontWeight: "bold",
							}}
						>
							{numberFormatter(data.modelledUnitPrice, 0, "$")}
						</label>
					</p>
					<p className="label" style={{ padding: "0", margin: "0" }}>
						<label
							style={{
								color: "#C8C8C8",
								fontSize: "10px",
								fontWeight: "normal",
							}}
						>
							Actual Unit Cost:{" "}
						</label>
						<label
							style={{
								color: "#EAEAEA",
								fontSize: "10px",
								fontWeight: "bold",
							}}
						>
							{numberFormatter(data.actualUnitCost, 0, "$")}
						</label>
					</p>
					<p className="label" style={{ padding: "0", margin: "0" }}>
						<label
							style={{
								color: "#C8C8C8",
								fontSize: "10px",
								fontWeight: "normal",
							}}
						>
							Spend:{" "}
						</label>
						<label
							style={{
								color: "#EAEAEA",
								fontSize: "10px",
								fontWeight: "bold",
							}}
						>
							{numberFormatter(data.ThisYear_Spend, 0, "$")}
						</label>
					</p>
				</div>
			);
		}
	};

	return (
		<>
			<div className="flex justify-center mt-[0.2vw]">
				<div className="flex items-center">
					<div className="w-2 h-2 rounded-full border-4 border-[#c32b2b]"></div>
					<p className="text-0.7vw pl-1">
						{" "}
						Higher than expected price
					</p>
				</div>

				<div className="flex items-center pl-2">
					<div className="w-2 h-2 rounded-full border-4 border-[#2ba1c3]"></div>
					<p className="text-0.7vw pl-1">
						{" "}
						Lower than expected price
					</p>
				</div>
			</div>
			<ResponsiveContainer width="100%" height="100%">
				<ScatterChart
					width={400}
					height={380}
					margin={{
						top: 20,
						right: 20,
						bottom: 20,
						left: 30,
					}}
				>
					<XAxis
						type="number"
						dataKey="modelledUnitPrice"
						stroke="black"
						tickFormatter={(val) => numberFormatter(val, 0, "$")}
					>
						<Label
							value="Modelled Unit Price"
							offset={0}
							position="bottom"
							style={{ fill: "black" }}
						/>
					</XAxis>
					<YAxis
						type="number"
						dataKey="actualUnitCost"
						stroke="black"
						tickFormatter={(val) => numberFormatter(val, 0, "$")}
					>
						<Label
							value="Actual Unit Cost"
							angle={-90}
							offset={-5}
							position="insideLeft"
							style={{ fill: "black", textAnchor: "middle" }}
						/>
					</YAxis>

					<ZAxis
						type="number"
						dataKey="ThisYear_Spend"
						range={data?.length <= 10 ? [100, 2000] : [50, 500]}
					/>

					{/* <ReferenceLine
            label="Segment"
            stroke="white"
            strokeDasharray="5 3"
            opacity={0.3}
            segment={[
              { x: 0, y: 0 },
              { x: `${data[data.length-1].modelledUnitPrice}`, y: `${data[data.length-1].modelledUnitPrice}` },
            ]}
          /> */}

					{/* <ReferenceLine
                x={refX}
                label={{
                position: "top",
                fill: "#ce9178",
                value: numberFormatter(refX, 2) + "%",
                fontStyle: "italic",
                }}
                stroke="white"
                strokeDasharray="5 3"
                opacity={0.3}
            />

            <ReferenceLine
                y={refY}
                label={{
                position: "right",
                fill: "#ce9178",
                value: numberFormatter(refY, 2) + "%",
                fontStyle: "italic",
                }}
                stroke="white"
                strokeDasharray="5 3"
                opacity={0.3}
            /> */}

					<Tooltip
						contentStyle={{
							color: "black",
							backgroundColor: "rgb(26, 25, 22)",
						}}
						cursor={{ strokeDasharray: "3 3" }}
						content={customTooltip}
					/>
					{/* <Legend /> */}
					{data?.map((d: any, index: number) => {
						console.log("***", d);
						return (
							<Scatter
								key={index}
								data={[d]}
								fill={
									d.actualUnitCost > d.modelledUnitPrice
										? "#FF9601"
										: "#056FAD"
								}
								name={
									d.actualUnitCost > d.modelledUnitPrice
										? "SKUs with higher-than-expected price"
										: "SKUs below expected price"
								}
							></Scatter>
						);
					})}
				</ScatterChart>
			</ResponsiveContainer>
		</>
	);
};

export default ParametricScatter;
